<template>
  <el-scrollbar>
    <div class="freebie">
      <nut-noticebar text="新品即将上市，活动期间可参与充值赠好礼，更多新品信息请持续关注！"></nut-noticebar>
      <template v-if="shopflag == 'fzth'">
        <img src="../assets/images/zptp.jpg" alt="赠品详情" srcset="">
        <img src="../assets/images/zptp1.jpg" alt="赠品详情" srcset="">
        <img src="../assets/images/zptp2.jpg" alt="赠品详情" srcset="">
      </template>
      <template v-if="shopflag == 'hzhb'">
        <!-- <img src="../assets/images/hzhb01.jpg" alt="赠品详情" srcset=""> -->
        <!-- <img src="../assets/images/hzhb02.jpg" alt="赠品详情" srcset=""> -->
        <img src="../assets/images/hzhb03.jpg" alt="赠品详情" srcset="">
      </template>
      <template v-if="shopflag == 'zhfh'">
        <img src="../assets/images/zhfh06.jpg" alt="赠品详情" srcset="">
        <img src="../assets/images/zhfh09.jpg" alt="赠品详情" srcset="">
      </template>
      <div class="freebie-btn">
        <div class="pay-contnet">
          <div class="pay-top">
            <div class="pay-top-left">
              <el-button @click="backRecharge" type="success">马上参与</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-scrollbar>
</template>
<script>
export default {
  data () {
    return {
      shopflag: ''
    }
  },
  methods: {
    backRecharge () {
      this.$router.push('/public/recharg')
    }
  },
  mounted () {},
  created () {
    let shop = window.location.hostname.split('.')[0]
    this.shopflag = shop
    // this.shopflag = 'zhfh'
  }
}
</script>
<style lang="less">
.freebie {
  font-size: 14px;
  width: 100%;
  position: relative;
  .nut-noticebar {
    height: 32px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 750px;
    .nut-noticebar {
      font-size: 14px;
    }
  }
  img {
    width: 100%;
    display: block;
    margin: 0;
  }
}
.freebie-btn {
  position: fixed;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  padding: 8px 64px;
  width: 100%;
  max-width: 750px;
  .pay-contnet {
    .pay-top {
      overflow: hidden;
      .pay-top-left,
      .pay-top-right {
        float: left;
        width: 100%;
        text-align: center;
        padding: 0;
        .el-button {
          width: 100%;
          font-size: 18px;
          padding: 8px 30px;
        }
      }
      .pay-top-right {
        padding: 0;
        padding-left: 8px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/PublicApp/components/Freebie.vue